module.exports = CONFIG;


//////////////////
// WEBPACK FOOTER
// external "CONFIG"
// module id = 467
// module chunks = 4